// Independent page composition for Test Automation Services.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function AutomationTestingPage({ service }) {
  return h(PageFrame, { service, tone: 'editorial', hero: diagram(service, 'loop') },
    section('Make improvement part of the operating model', context(service), { className: 'ai-narrow-section' }),
    section('Build a repeatable capability', deliverables(service)),
    section(null, split(scenario(service), answer(service)), { theme: 'ai-wash' }),
    section(null, scope(), { className: 'ai-narrow-section' })
  );
};
